// Re-export LandingService from shared
export { LandingService } from '@/services/shared'
